import React, {useState} from "react";
import moment from "moment";
import styles from "./ShowCertificate.module.scss";
import {OverviewBanner, Button} from "@netapp/bxp-design-system-react";
import { SuccessIcon } from "@netapp/bxp-style/react-icons/Notification";
import {ViewSignedCertificate, ChangeExistingModal} from "./HttpsModals";
import {useSelector} from "react-redux";
import usePermission from "utils/usePermission";
import PermissionComponent from "modules/app/components/permission/PermissionComponent";
import { useTranslation} from 'react-i18next';
import { connectorsettings as i18nNamespace} from "../../../../i18n/namespace";

const Row = ({name, value}) => {
    return <div>
        <div className={styles["row"]}>
            <div>{name}</div>
            < div title={value} className={styles["cert-info"]}>{value}</div>
        </div>
    </div>
}

export default React.memo(() => {
    const signedCertificate = useSelector(state => state.connectorSettings.https.signedCertificate);
    const [viewCertificate, setViewCertificate] = useState(false);
    const [changeCertificate, setChangeCertificate] = useState(false);
    const hasPermission = usePermission(["https_setup", "httpsetup"]);
    const { t } = useTranslation(i18nNamespace);
    
    
    return <>
        {viewCertificate &&
        <ViewSignedCertificate certificate={signedCertificate.certificate}
                               closeTrigger={() => setViewCertificate(false)}/>}
        {changeCertificate && <ChangeExistingModal closeTrigger={() => setChangeCertificate(false)}/>}
        <div className={styles["base"]}>
            <div className={styles["header"]}>
                <div>{t("https_certificate")}</div>
                <PermissionComponent hasPermssion={hasPermission({
                        permissionType: "modify"
                    })}>
                    <Button color="secondary" onClick={() => setChangeCertificate(true)}>{t("change_certificate")}</Button>
                </PermissionComponent>
            </div>
            <OverviewBanner className={styles["view-certificate"]}>
                <div>
                    <SuccessIcon className={styles["check-icon"]} color="success"/>
                    <div className={styles["https-active"]}>{t("https_active")}</div>
                </div>
                <Row name={t("expiration")} value={moment(signedCertificate.endDate).format(t("https_date_format"))}/>
                <Row name={t("issuer")} value={signedCertificate.directIssuerName}/>
                <Row name={t("subject")} value={signedCertificate.subjectName}/>
                <Row name={t("certificate")}
                     value={<Button type="text" onClick={() => setViewCertificate(true)}>{t("view_certificate")}</Button>}/>
            </OverviewBanner>
        </div>
    </>
});
